const breakpoints = {
  MOBILE: 740,
  TABLET: 970,
  DESKTOP_SMALL: 1024,
  DESKTOP: 1140,
};

export default breakpoints;
